import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import * as types from "./types";


class MessageBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      message: "",
      title: "",
      callbackFunction: {},
      isProcessing: false
    }
  }
  setShow = (value) => {
    this.setState({
      show: value
    })
  }


  handleClose = async (result) => {
    // Guards against a second tap firing the callback again while the first
    // one (e.g. invoiceIssue) is still in flight.
    if (this.state.isProcessing) {
      return;
    }
    const returnValue = this.state.callbackFunction(result);
    // If the callback returns a promise (e.g. an in-flight API call), keep the
    // dialog open with its buttons disabled until it settles, instead of
    // closing immediately and allowing a duplicate action to be triggered.
    if (returnValue && typeof returnValue.then === "function") {
      this.setState({ isProcessing: true });
      try {
        await returnValue;
      } finally {
        this.setState({
          show: false,
          message: "",
          title: "",
          callbackFunction: null,
          isProcessing: false
        })
      }
    } else {
      this.setState({
        show: false,
        message: "",
        title: "",
        callbackFunction: null
      })
    }
  }

  handleShow = () => this.setShow(true);

  showMessage = (message, title, callbackFunction) => {
    return this.setState({
      show: true,
      message: message,
      title: title,
      callbackFunction: callbackFunction,

    })
  }

  render() {
    return (

        <Modal
          show={this.state.show}
          onHide={() => this.handleClose(types.MESSAGEBOX_RESPONSE_CANCELLED)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
    <Modal.Title>{this.state.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" disabled={this.state.isProcessing} onClick={() => this.handleClose(types.MESSAGEBOX_RESPONSE_YES)}>
              Igen
            </Button>
            <Button variant="primary" disabled={this.state.isProcessing} onClick={() => this.handleClose(types.MESSAGEBOX_RESPONSE_NO)}>
              Nem
            </Button>
          </Modal.Footer>
        </Modal>

    )
  }
}




export default MessageBox;
